module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.3ac6f5a4.svg";